/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getMessages = /* GraphQL */ `query GetMessages($messageId: String!) {
  getMessages(messageId: $messageId) {
    messageId
    message
    presentationId
    senderEmail
    senderName
    sentDate
    state
    lastChanges
    presentationTitle
    prioritizeIndex
    senderStatus
    aiResponse
    topic
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessagesQueryVariables,
  APITypes.GetMessagesQuery
>;
export const listMessages = /* GraphQL */ `query ListMessages(
  $presentationId: String!
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listMessages(
    presentationId: $presentationId
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      messageId
      message
      presentationId
      senderEmail
      senderName
      sentDate
      state
      lastChanges
      presentationTitle
      prioritizeIndex
      senderStatus
      aiResponse
      topic
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMessagesQueryVariables,
  APITypes.ListMessagesQuery
>;
export const getInterfaceSettings = /* GraphQL */ `query GetInterfaceSettings($presentationId: String!) {
  getInterfaceSettings(presentationId: $presentationId) {
    presentationId
    reviewMode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInterfaceSettingsQueryVariables,
  APITypes.GetInterfaceSettingsQuery
>;
export const getChatMessages = /* GraphQL */ `query GetChatMessages($chatMessageId: String!) {
  getChatMessages(chatMessageId: $chatMessageId) {
    chatMessageId
    presentationId
    senderName
    createdAt
    message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChatMessagesQueryVariables,
  APITypes.GetChatMessagesQuery
>;
export const listChatMessages = /* GraphQL */ `query ListChatMessages(
  $presentationId: String!
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listChatMessages(
    presentationId: $presentationId
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      chatMessageId
      presentationId
      senderName
      createdAt
      message
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChatMessagesQueryVariables,
  APITypes.ListChatMessagesQuery
>;
export const getPoll = /* GraphQL */ `query GetPoll($presentationId: String!, $pollId: String!) {
  getPoll(presentationId: $presentationId, pollId: $pollId) {
    pollId
    presentationId
    hideForPresenter
    order
    status
    type
    value
    publicAdjustment
    poll_in_progress_timestamp
    poll_completed_timestamp
    countVotes
    result_slide_added
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPollQueryVariables, APITypes.GetPollQuery>;
export const listPolls = /* GraphQL */ `query ListPolls(
  $presentationId: String!
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listPolls(
    presentationId: $presentationId
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      pollId
      presentationId
      hideForPresenter
      order
      status
      type
      value
      publicAdjustment
      poll_in_progress_timestamp
      poll_completed_timestamp
      countVotes
      result_slide_added
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListPollsQueryVariables, APITypes.ListPollsQuery>;
export const listPollChoices = /* GraphQL */ `query ListPollChoices(
  $pollId: String!
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listPollChoices(
    pollId: $pollId
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    pollChoicesCountedList {
      pollId
      pollChoiceId
      isCustomResponse
      order
      value
      status
      count
      __typename
    }
    nextToken
    allVotesCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPollChoicesQueryVariables,
  APITypes.ListPollChoicesQuery
>;
export const getMediaLiveChannelStatus = /* GraphQL */ `query GetMediaLiveChannelStatus($channelId: String!) {
  getMediaLiveChannelStatus(channelId: $channelId) {
    account_id
    channel_info {
      inputReceivedDate
      isSynced
      processingPipeline
      __typename
    }
    created_by_user
    created_date
    hls_link
    id
    live_stream_provider
    modified_by_user
    modified_date
    name
    presentation_id
    profile
    rtmp_input_id
    rtmp_link
    start_date
    state
    sync_flow
    unique_identifier
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMediaLiveChannelStatusQueryVariables,
  APITypes.GetMediaLiveChannelStatusQuery
>;
export const getPollVoteByUniqueViewerIdAndPollId = /* GraphQL */ `query GetPollVoteByUniqueViewerIdAndPollId(
  $uniqueViewerId: String!
  $pollId: String!
  $presentationId: Int!
) {
  getPollVoteByUniqueViewerIdAndPollId(
    uniqueViewerId: $uniqueViewerId
    pollId: $pollId
    presentationId: $presentationId
  ) {
    items {
      pollId
      uniqueViewerId
      pollChoiceId
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPollVoteByUniqueViewerIdAndPollIdQueryVariables,
  APITypes.GetPollVoteByUniqueViewerIdAndPollIdQuery
>;
export const getAttendees = /* GraphQL */ `query GetAttendees($input: String!) {
  getAttendees(input: $input)
}
` as GeneratedQuery<
  APITypes.GetAttendeesQueryVariables,
  APITypes.GetAttendeesQuery
>;
export const getActiveAttendeesCount = /* GraphQL */ `query GetActiveAttendeesCount($input: String!) {
  getActiveAttendeesCount(input: $input)
}
` as GeneratedQuery<
  APITypes.GetActiveAttendeesCountQueryVariables,
  APITypes.GetActiveAttendeesCountQuery
>;
